export type StringKey =
  | 'dashboard_welcome'
  | 'dashboard_no_trips'
  | 'dashboard_no_locations'
  | 'discover_title'
  | 'discover_explore_subtitle'
  | 'discover_library_subtitle'
  | 'discover_library_empty'
  | 'trip_no_days'
  | 'trip_export_pdf'
  | 'trip_export_calendar'
  | 'passport_empty'
  | 'passport_title'
  | 'rewards_title'
  | 'stamp_claimed'
  | 'daily_checkin_prompt'
  | 'daily_checkin_claimed'
  | 'search_placeholder'
  | 'save_location'
  | 'create_trip'
  | 'continue_planning'
  | 'spot_claimed_toast'
  | 'checkin_toast';

const DEFAULT_STRINGS: Record<StringKey, string> = {
  dashboard_welcome: 'Welcome back!',
  dashboard_no_trips: 'No trips planned yet',
  dashboard_no_locations: 'No locations saved yet',
  discover_title: 'Discover',
  discover_explore_subtitle: 'Find amazing places across Japan',
  discover_library_subtitle: 'Manage your saved locations',
  discover_library_empty: 'Your library is empty. Browse Explore to find places!',
  trip_no_days: 'No days added to your trip yet',
  trip_export_pdf: 'PDF',
  trip_export_calendar: 'iCal',
  passport_empty: 'Your passport is empty',
  passport_title: 'Passport',
  rewards_title: 'Rewards',
  stamp_claimed: 'Spot claimed! Check your passport.',
  daily_checkin_prompt: 'Claim your daily check-in credits',
  daily_checkin_claimed: 'Check-in complete!',
  search_placeholder: 'Search places in Japan...',
  save_location: 'Save',
  create_trip: 'Create Trip',
  continue_planning: 'Continue Planning',
  spot_claimed_toast: 'Spot claimed! Check your passport.',
  checkin_toast: 'Check-in complete! +10 credits',
};

const SENSEI_STRINGS: Record<StringKey, string> = {
  dashboard_welcome: 'Welcome back, traveler-san! Ready to deepen your Japan knowledge?',
  dashboard_no_trips: 'Every great journey begins with a single step. Plan your first trip to Japan!',
  dashboard_no_locations: 'A wise traveler studies the map before the journey. Start discovering locations!',
  discover_title: 'Discover Japan',
  discover_explore_subtitle: 'Your sensei has curated these remarkable places across Japan',
  discover_library_subtitle: 'Your personal collection of Japan knowledge',
  discover_library_empty: 'A sensei\'s library starts with one scroll. Save your first location from Explore!',
  trip_no_days: 'Like a blank scroll awaiting the brush \u2014 add days to begin your itinerary',
  trip_export_pdf: 'Print Scroll',
  trip_export_calendar: 'iCal',
  passport_empty: 'Your Hanko passport awaits its first seal. Visit a location to earn your first stamp!',
  passport_title: 'Hanko Passport',
  rewards_title: 'Achievements',
  stamp_claimed: 'Excellent! A new seal for your collection. Your passport grows!',
  daily_checkin_prompt: 'A diligent student checks in every day. Claim your wisdom credits!',
  daily_checkin_claimed: 'Discipline rewarded! Your streak grows stronger.',
  search_placeholder: 'Seek knowledge about Japan...',
  save_location: 'Study This',
  create_trip: 'Plan Journey',
  continue_planning: 'Resume Studies',
  spot_claimed_toast: 'Your sensei is proud! New seal earned for your Hanko passport.',
  checkin_toast: 'Daily practice makes the master! +10 credits earned.',
};

const MANGA_STRINGS: Record<StringKey, string> = {
  dashboard_welcome: 'Previously on your Japan adventure... 📖',
  dashboard_no_trips: 'Every manga needs a first chapter. Start writing your Japan story!',
  dashboard_no_locations: 'Your story needs settings! Discover locations to fill your panels.',
  discover_title: 'Location Archive',
  discover_explore_subtitle: 'Browse settings for your next chapter',
  discover_library_subtitle: 'Your collection of story settings',
  discover_library_empty: 'No settings collected yet. Browse the archive to find your scenes!',
  trip_no_days: 'A blank page awaits your story. Add days to begin Chapter 1!',
  trip_export_pdf: 'Print Chapter',
  trip_export_calendar: 'iCal',
  passport_empty: 'No panels collected yet. Visit locations to fill your storyboard!',
  passport_title: 'Story Archive',
  rewards_title: 'Achievements',
  stamp_claimed: 'New panel added to your storyboard! 📖',
  daily_checkin_prompt: 'The author checks in daily. Claim your ink credits!',
  daily_checkin_claimed: 'Another page in your journey!',
  search_placeholder: 'Search for story settings...',
  save_location: 'Add to Script',
  create_trip: 'New Chapter',
  continue_planning: 'Continue Writing',
  spot_claimed_toast: 'Panel collected! Your manga grows. 📖',
  checkin_toast: 'Daily author check-in complete! +10 credits.',
};

export function getExperienceStrings(mode: string | null): Record<StringKey, string> {
  if (mode === 'exp-sensei') return SENSEI_STRINGS;
  if (mode === 'exp-manga') return MANGA_STRINGS;
  return DEFAULT_STRINGS;
}
